module.exports = __webpack_public_path__ + "media/images/landing/browser_planning.es-original-24e4c90f8588a9902899083bcc90dd2b.png";